"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createD2CMessage = exports.createC2DMessage = exports.createSetOperatingModeCommand = exports.GetStateCommand = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const class_1 = require("../../device/class");
const message_1 = require("./message");
exports.NAMESPACE = 'Culligan.Protocol.V3.State';
exports.GetStateCommand = effect_1.Schema.Struct({ command: effect_1.Schema.tag('state.get') }).annotations({
    identifier: `${exports.NAMESPACE}.GetStateCommand`,
    title: 'Get State',
    description: 'Instruct the device to send a state message with its current state',
});
const createSetOperatingModeCommand = (state) => effect_1.Schema.Struct({
    command: effect_1.Schema.tag('operating_mode.set'),
    params: state.pipe(effect_1.Schema.pick('operatingMode')),
}).annotations({
    identifier: `${exports.NAMESPACE}.SetOperatingModeCommand`,
    title: 'Set Operating Mode',
    description: 'Instruct the device to set its operating mode to the given value',
});
exports.createSetOperatingModeCommand = createSetOperatingModeCommand;
const createC2DMessage = (state) => (0, message_1.createMessage)('command', effect_1.Schema.Union(exports.GetStateCommand, (0, exports.createSetOperatingModeCommand)(state))).annotations({
    title: 'State Message',
    description: 'A Cloud-To-Device message related to device state',
});
exports.createC2DMessage = createC2DMessage;
const createD2CMessage = (state) => {
    const stateSchema = state.pipe(effect_1.Schema.extend(class_1.Base.CommonProps.pick('swVersion', 'hwVersion')), effect_1.Schema.encodedBoundSchema, effect_1.Schema.partialWith({ exact: true }));
    return (0, message_1.createMessage)('state', stateSchema).annotations({
        title: 'State Message',
        description: 'A Device-To-Cloud message on the "state" channel',
    });
};
exports.createD2CMessage = createD2CMessage;
//# sourceMappingURL=state.js.map